//忘记密码
export default{
  path: '/login',
  component: resolve=>require(['@/views/main.vue'],resolve),
  children:[
    {path:'forgetPassword',component:resolve=>require(['@/views/login/forget_password.vue'],resolve)}
  ]
}
